import { render, staticRenderFns } from "./widgety-itinerary.vue?vue&type=template&id=52e8235e&scoped=true"
import script from "./widgety-itinerary.vue?vue&type=script&lang=js"
export * from "./widgety-itinerary.vue?vue&type=script&lang=js"
import style0 from "./widgety-itinerary.vue?vue&type=style&index=0&id=52e8235e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e8235e",
  null
  
)

export default component.exports